import _ from 'lodash';

class PivotCube {
  constructor(mesures, columns, rows) {
    this._mesures = mesures;
    this._columns = columns;
    this._rows = rows;
  }

  get measures() {
    return _.reduce(this._mesures, (res, cur) => {
      res[cur.title || cur.field] = {
        field: cur.field,
        aggregate: cur.type
      };
      return res;
    }, {});
  }

  get dimensions() {
    return _(this._columns)
        .concat(this._rows)
        .reduce((res, cur) => {
          res[cur.field] = {
            caption: cur.title
          };
          return res;
        }, {});
  }

  listMeasures() {
    return _.map(this.measures, (v, k) => (k));
  }
}

export default PivotCube;
